import { module } from 'angular';

import { AgentViewIndicators, default as agentViewIndicatorsName } from './indicators/agent-view-indicators.component.ajs';

export default module('contact.agent.agent-view', [])
  // COMPONENT
  .component(agentViewIndicatorsName, new AgentViewIndicators()).name;
